import React, { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

function PaymentSuccessPage() {
  const [secondsRemaining, setSecondsRemaining] = useState(5);
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("session_id");
  const paymentIntent = searchParams.get("payment_intent");
  const redirectStatus = searchParams.get("redirect_status");

  const attemptCloseWindow = useCallback(() => {
    try {
      window.location.href = 'nclood://payment-success';
      //window.close();
    } catch {}
    try {
      window.open('', '_self');
      window.close();
    } catch {}
    /*window.setTimeout(() => {
      if (!window.closed) {
        window.location.replace('/');
      }
    }, 200);*/
  }, []);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          window.clearInterval(intervalId);
          attemptCloseWindow();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-2xl font-semibold mb-4">Payment successful</h1>
      <p className="mb-2">Thank you! Your payment has been processed successfully.</p>
      <p className="mb-6" aria-live="polite">You can close this window now.</p>      
      
    </div>
  );
}

export default PaymentSuccessPage;


